import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import SignUp from '@/components/SignUp'
import Home from '@/components/Home'
import Profile from '@/components/Profile'
import Todos from '@/components/Todos'
import Create from '@/components/Create'
import Admin from '@/components/Admin'
import List from '@/components/List'
import Merchants from '@/components/Merchants'
import Policy from '@/components/Policy'

import firebase from 'firebase'

Vue.use(Router)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          auth: true
        }

      },
      {
        path: '/todo',
        name: 'Todos',
        component: Todos,
        meta: {
          auth: true
        }
      }, 
      {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
          guest: true
        }

      },
      {
        path: '/signup',
        name: 'SignUp',
        component: SignUp,
        meta: {
          guest: true
        }
      },
      {
        path: '/',
        name: 'Login',
        component: Login,
        meta: {
          guest: true
        }
      },
      {
        path: '/create',
        name: 'Create',
        component: Create,

      },
      {
        path: '/home',
        name: 'Admin',
        component: Admin,
        meta: {
          auth: true
        }
      },
      // {
      //   path: '/new',
      //   name: 'New',
      //   component: New,
      //   meta: {
      //     auth: true
      //   }
        
      // },
      {
        path: '/merchants',
        name: 'Merchants',
        component: Merchants,
        meta: {
          auth: true
        }
        
      },
      {
        path: '/policy',
        name: 'Policy',
        component: Policy,
        meta: {
          guest: true
        }
      },
      {
        path: '/list',
        name: 'List',
        component: List,
        meta: {
          auth: true
        }
      },
      {
        path:'ad',
        name:'new-ad',
        component: () => import(/* webpackChunkName: "admin" */ '../components/Ad.vue'),
        meta: {
          auth: true
        }
      },
      {
        path:'ad/:id',
        name:'new-ad',
        component: () => import(/* webpackChunkName: "admin" */ '../components/Ad.vue'),
        meta: {
          auth: true
        }
      },
    ]

  },

)


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next()
      } else {
        next({
          path: "/login",
        })
      }
    })
  } else if (to.matched.some(record => record.meta.guest)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next({
          path: "/profile",
        })
      } else {
        next()
      }
    })

  } else {
    next()
  }

})

export default router
